<template>
  <div class="edit-password">
    <div class="top-title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>修改密码</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row type="flex" justify="center">
      <el-col :span="12">
        <el-form :model="passwordForm" :rules="passwordFormRules" ref="passwordForm" label-width="120px">
          <!-- <el-form-item label="输入原始密码" prop="oldPassword">
            <el-input v-model="passwordForm.oldPassword" type="password"></el-input>
          </el-form-item> -->
          <el-form-item label="输入新密码" prop="password">
            <el-input v-model.trim="passwordForm.password" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="passwordAgain">
            <el-input v-model.trim="passwordForm.passwordAgain" type="password"></el-input>
          </el-form-item>
        </el-form>
        <span class="dialog-footer">
          <el-button type="primary" @click="submit">提交</el-button>
          <el-button @click="reset">重置</el-button>
        </span>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data () {
    const checkPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error('密码不能为空！'))
      } else if (value.length < 8) {
        callback(new Error('密码必须8位以上！'))
      } else if (!this.checkPwd(value)) {
        callback(new Error('密码包含数字 大小写字母 特殊符号的三种！'))
      } else {
        callback()
      }
    }
    const checkPwdAgain = (rule, value, callback) => {
      if (value !== this.passwordForm.password) {
        callback(new Error('两次密码输入不一致！'))
      } else if (!value) {
        callback(new Error('确认密码不能为空！'))
      } else {
        callback()
      }
    }
    return {
      id: sessionStorage.getItem('userId'),
      passwordForm: {
        password: '',
        passwordAgain: ''
      },
      passwordFormRules: {
        password: {required: true, validator: checkPwd, trigger: 'blur'},
        passwordAgain: {required: true, validator: checkPwdAgain, trigger: 'blur'}
      }
    }
  },
  methods: {
    // 提交
    submit () {
      this.$refs.passwordForm.validate(async valid => {
        if (valid) {
          if (this.passwordForm.password !== this.passwordForm.passwordAgain) return this.$message.warning('两次密码输入不一致')
          let { data: res } = await this.$http.post('/api/user/modfiyPassword', {password: this.passwordForm.password, id: this.id})
          if (res.code === 200) {
            this.$message.success(res.msg)
            this.$router.push('login')
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    // 重置
    reset () {
      this.$nextTick(() => {
        this.$refs.passwordForm.resetFields()
      })
    },

    // 规则长度至少8，包含数字大小写字母特殊符号的三种
    checkPwd (value) {
      let str = [
        /(?=.*[0-9])/,
        /(?=.*[A-Z])/,
        /(?=.*[a-z])/,
        /(?=.*[!@#$%^&*?])/
      ]
      let cont = 0
      for (let i = 0; i < 4; i++) {
        if (str[i].test(value)) {
          cont++
        }
      }
      if (cont < 3) {
        return false
      }
      return true
    }
  }
}
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/pages/password/editPassword.vue